module.exports = __webpack_public_path__ + "img/breatlas.38761e03.jpg";